<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.manage.notes.notes' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="notes-header-container">
        <div [ngClass]="{ 'selected' : selectedNoteType === 'INTERNAL' }" (click)="selectNoteType('INTERNAL')">
            {{'bikeshop.workshop.jobcard.quote.internal' |
            translate}}<span>{{internalNotes.notes?.length || 0}}</span></div>
        <div [ngClass]="{ 'selected' : selectedNoteType === 'EXTERNAL' }" (click)="selectNoteType('EXTERNAL')">
            {{'bikeshop.workshop.jobcard.quote.external' |
            translate}}<span>{{externalNotes.notes?.length || 0}}</span></div>
        <div [ngClass]="{ 'selected' : selectedNoteType === 'CLIENTNOTES' }" (click)="selectNoteType('CLIENTNOTES')">
            {{'bikeshop.modal.update_job_card.job_card.customer_notes' |
            translate}}<span>{{clientNotes.notes?.length || 0}}</span></div>


        <hub-button *ngIf="!editableNote.newNote" [style]="'outline'" [size]="'xl'" [icon]="'plus-alt'"
            (buttonClick)="setNewNote()"></hub-button>
    </div>
    <div class="notes-description">
        {{ selectedNoteType === 'INTERNAL' ? ('bikeshop.workshop.jobcard.manage.notes.internal_description' |
        translate) : ('bikeshop.workshop.jobcard.manage.notes.external_description' | translate) }}
    </div>
    <div class="notes-main-container">
        <div>
            <div class="notes-container">
                <div *ngIf="getCurrentNotes().length === 0" class="no-notes">
                    {{ (selectedNoteType === 'INTERNAL' ? 'bikeshop.workshop.jobcard.manage.notes.no_internal_notes' :
                    'bikeshop.workshop.jobcard.manage.notes.no_external_notes') | translate }}
                </div>

                <div *ngFor="let note of getSortedNotes(); let i = index">

                    <!-- Show date separator when date changes -->
                    <div *ngIf="shouldShowDateSeparator(note, i)" class="date-separator">
                        <span class="date-text">{{ getDateDisplayText(note.createdDate) }}</span>
                    </div>

                    <!-- Note Item -->
                    <div class="note-item" (click)="editNote(note)"
                        [ngClass]="{ 'selected': editableNote.id === note.id }">
                        <div class="note-header">
                            <div class="note-date">{{ note.createdDate+'Z' | date: countryData.AngularDateFormat + '
                                h:mm a' }}</div>
                            <div class="note-updated" *ngIf="note.createdDate !== note.updatedDate && note.id > 0">{{
                                'bikeshop.workshop.jobcard.manage.notes.updated' | translate }}</div>
                        </div>
                        <div class="note-text">{{ note.note }}</div>
                    </div>
                </div>
            </div>


        </div>
        <div>
            <div class="note-create-container">
                <div><textarea #noteInput [(ngModel)]="editableNote.note"
                        placeholder="{{ 'bikeshop.workshop.jobcard.manage.notes.add_note_placeholder' | translate }}"></textarea>
                </div>
                <div>
                    <div *ngIf="editableNote.newNote"></div>
                    <div *ngIf="editableNote.newNote"><hub-button [style]="'secondary'"
                            [disabled]="editableNote.note.trim().length === 0 || updatingNote" [loading]="updatingNote"
                            (buttonClick)="saveNote()"
                            text="{{ 'bikeshop.workshop.jobcard.manage.notes.save_note' | translate }}"></hub-button>
                    </div>
                    <div *ngIf="!editableNote.newNote"><hub-button [style]="'outline'" (buttonClick)="deleteNote()"
                            [disabled]="updatingNote" [loading]="updatingNote"
                            text="{{ 'bikeshop.workshop.jobcard.manage.notes.delete_note' | translate }}"></hub-button>
                    </div>
                    <div *ngIf="!editableNote.newNote"><hub-button [style]="'secondary'"
                            [disabled]="editableNote.note.trim().length === 0 || editableNote.note === editableNote.originalNote || updatingNote"
                            [loading]="updatingNote" (buttonClick)="updateNote()"
                            text="{{ 'bikeshop.workshop.jobcard.manage.notes.update_note' | translate }}"></hub-button>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<p-toast position="bottom-center" styleClass="hubtiger-jobcard-toast" key="notes"></p-toast>
